import { render, staticRenderFns } from "./CRMActivity.vue?vue&type=template&id=7ee28810&scoped=true&"
import script from "./CRMActivity.vue?vue&type=script&lang=js&"
export * from "./CRMActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee28810",
  null
  
)

export default component.exports